import formatName from 'I18n/utils/formatName';
import UserContainer from 'documents-ui/lib/containers/UserContainer';
export function isOwnedByCurrentUser(userId) {
  return userId === UserContainer.get().user_id;
}
export function getOwnerName(owner) {
  return formatName(owner.toObject());
}